import {
    SET_INITIALIZATION,
    SET_P13N_DATA_FOR_PREVIEW,
    SET_P13N_DATA,
    SET_P13N_VARIATIONS,
    SET_ACTIVE_P13N_VARIATION,
    SET_SID_DATA,
    UPDATE_SID_DATA,
    SET_ORIGINAL_BANNER_SID,
    SET_CAROUSEL_ACTIVE_PAGE,
    SET_REPLEN_P13N_DATA,
    SET_RTCO_P13N_DATA,
    SET_RECAP_P13N_AB_TEST_DATA,
    SET_PUWYLO_BATCH_DATA,
    SET_TRENDING_CONTENT_DATA,
    SET_TRENDING_CONTENT_LOADING
} from 'constants/actionTypes/personalization';

const initialState = {
    isInitialized: false,
    variations: {},
    activeVariations: {},
    sid: [],
    data: [],
    originalBannerSid: null,
    carouselActivePage: null,
    replenData: null,
    rtcoData: null,
    recapABTestData: null,
    puwyloBatchData: null,
    trendingContent: {}
};

const reducer = function (state = initialState, { type, payload }) {
    switch (type) {
        case SET_INITIALIZATION:
            return Object.assign({}, state, {
                isInitialized: payload
            });

        case SET_P13N_DATA_FOR_PREVIEW:
            return Object.assign({}, state, {
                isInitialized: true,
                data: [...state.data, ...payload]
            });

        case SET_P13N_DATA:
            return Object.assign({}, state, {
                isInitialized: true,
                headData: payload
            });

        case SET_P13N_VARIATIONS:
            return Object.assign({}, state, {
                variations: {
                    ...state.variations,
                    ...payload
                }
            });

        case SET_ACTIVE_P13N_VARIATION:
            return Object.assign({}, state, {
                activeVariations: {
                    ...state.activeVariations,
                    ...payload
                }
            });

        case SET_SID_DATA:
            return Object.assign({}, state, {
                sid: [...state.sid, payload]
            });

        case UPDATE_SID_DATA: {
            const nextState = {
                ...state
            };

            nextState.sid[nextState.sid.indexOf(payload.prevSid)] = payload.currentSid;

            return nextState;
        }

        case SET_ORIGINAL_BANNER_SID:
            return Object.assign({}, state, {
                originalBannerSid: payload
            });

        case SET_CAROUSEL_ACTIVE_PAGE:
            return Object.assign({}, state, {
                carouselActivePage: payload
            });

        case SET_REPLEN_P13N_DATA:
            return Object.assign({}, state, {
                replenData: payload
            });

        case SET_RTCO_P13N_DATA:
            return Object.assign({}, state, {
                rtcoData: payload
            });
        case SET_RECAP_P13N_AB_TEST_DATA:
            return Object.assign({}, state, {
                recapABTestData: payload
            });

        case SET_PUWYLO_BATCH_DATA:
            return Object.assign({}, state, {
                puwyloBatchData: payload
            });

        // Marks a placement's trending fetch as in-flight so the banner keeps its skeleton for the
        // whole request (sticky), instead of falling back to default content while the derived
        // isTrendingContentEnabled flag settles.
        case SET_TRENDING_CONTENT_LOADING:
            return Object.assign({}, state, {
                trendingContent: {
                    ...state.trendingContent,
                    [payload.placement]: { pending: true }
                }
            });

        case SET_TRENDING_CONTENT_DATA:
            return Object.assign({}, state, {
                trendingContent: {
                    // Keep sibling placements' entries — the homepage has two trending placements
                    // (hpmktg + hphc) that each dispatch independently. Without this spread the
                    // second dispatch wipes the first, leaving that banner stuck in its skeleton.
                    ...state.trendingContent,
                    [payload.placement]: {
                        variationData: payload.variationData,
                        akamaiabtestdata: payload.akamaiabtestdata
                    }
                }
            });

        default:
            return state;
    }
};

export default reducer;
